'use strict';

import FieldView from '../Field';

class NumberField extends FieldView{
}

export default NumberField;
